import type { ReactNode } from "react";
import styles from "./Callout.module.css";

type Tone = "info" | "warning" | "danger" | "success";

interface CalloutProps {
  tone?: Tone;
  title?: ReactNode;
  children: ReactNode;
}

// Announce by purpose: errors/warnings interrupt (alert), success is polite
// (status), static info stays a passive note. Fixes query-error Callouts that
// were silent to screen readers (WCAG 4.1.3). role="alert"/"status" carry their
// own aria-live semantics, so no explicit aria-live attribute is needed.
const TONE_ROLE: Record<Tone, "alert" | "status" | "note"> = {
  info: "note",
  success: "status",
  warning: "alert",
  danger: "alert",
};

export function Callout({ tone = "info", title, children }: CalloutProps) {
  return (
    <div className={[styles.callout, styles[tone]].join(" ")} role={TONE_ROLE[tone]}>
      <span className={styles.dot} aria-hidden="true" />
      <div className={styles.body}>
        {title && <p className={styles.title}>{title}</p>}
        <div className={styles.text}>{children}</div>
      </div>
    </div>
  );
}
